export const rigthWrapperButtons = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: "flex-end",
  gap: '12px',
  maxWidth: '172px',
  width: '100%',

  '@media (max-width: 768px)': {
    position: 'absolute',
    right: '16px',
    top: '16px',
  },
};

export const detailBtn = {
  border: '1px solid var(--primary)',
  fontSize: '15px',
  borderRadius: '20px',
  color: 'var(--primary)',
  width: '73px',
  height: 'auto',
  textTransform: 'none',
};

export const customTooltip = {
  fontWeight: '400',
  fontSize: '15px',
  padding: '8px 16px',
  background: '#313031',
  color: 'var(--white)',
  maxWidth: 'none;',
};

export const ActionBtn = {
  width: '40px',
  height: '40px',
  border: '1px solid var(--grey200)',
  padding: '0',

  svg: {
    fill: 'var(--textMain)',
  },
};

export const ActionMenu = {
  '.MuiMenu-paper': {
    boxShadow: '0px 0px 20px 0px #0000000D',
    borderRadius: '20px',
    border: '1px solid var(--grey200)',

    '.MuiList-root': {
      padding: '10px 0',

      '.MuiMenuItem-root': {
        padding: '5px 20px',
      },
    },
  },
};

export const MobileActionBar = {
  position: 'fixed',
  left: '0',
  bottom: '0',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  background: 'var(--white)',
  boxShadow: '0px 0px 20px 0px #0000000D',
  transform: 'translateY(100%)',
  transition: 'transform .3s',
  padding: '40px 16px 16px',
  borderRadius: '20px 20px 0 0',
  textAlign: 'center',
  zIndex: '1',

  '&.is-mobile-bar': {
    transform: 'translateY(0)',
  },

  '.close-icon': {
    position: 'absolute',
    right: '6px',
    top: '6px',
  },
};

export const MobileOverlay = {
  position: 'fixed',
  left: '0',
  top: '0',
  width: '100%',
  height: '100%',
  backdropFilter: 'blur(10px)',
  zIndex: '1',
};

export const QrItemBtn = {
  borderRadius: '20px',
  width: '100%',
  padding: '7px',
  fontWeight: '500',
  fontSize: '18px',
  color: 'var(--primary)',
  border: '1px solid var(--primary)',

  '&.is-delete': {
    color: 'var(--darkRed)',
    border: '1px solid var(--darkRed)',
  },
};
